import React, { Component } from 'react'
import { css } from '@emotion/css'
import { VulnerabilityPolicy } from '../index'
import { Toggle } from '../../../legacy-design-system/toggle'
import { VulnerabilityPoliciesEnableMutation } from '../vulnerability-policies-enable-mutation'

interface ToggleCellProps {
  readonly organizationID: string
  readonly rowData: ToggleCellRowData
  readonly dataE2e?: string
}

interface ToggleCellRowData extends VulnerabilityPolicy {
  readonly disabled: boolean
}

interface State {
  readonly disabled: boolean
  readonly checked: boolean
}

export class ToggleCell extends Component<ToggleCellProps, State> {
  constructor(props: ToggleCellProps) {
    super(props)

    this.state = {
      disabled: props.rowData.disabled,
      checked: props.rowData.enabled
    }
  }

  public render() {
    const {
      organizationID,
      dataE2e,
      rowData: { id }
    } = this.props

    const { checked, disabled } = this.state

    return (
      <div
        data-e2e={dataE2e}
        className={css`
          display: flex;
          justify-content: center;
          align-items: center;
        `}
      >
        <VulnerabilityPoliciesEnableMutation>
          {(enablePolicy) => (
            <Toggle
              disabled={disabled}
              checked={checked}
              onChange={() => {
                this.setState({ disabled: true })

                enablePolicy({
                  variables: {
                    organizationID,
                    policyID: id
                  }
                })
                  .then(() => this.setState({ checked: !checked }))
                  .finally(() => this.setState({ disabled: false }))
              }}
            />
          )}
        </VulnerabilityPoliciesEnableMutation>
      </div>
    )
  }
}
